import { mount, unmount } from 'svelte'
import type { Starter } from 'shared/javascripts/chat_bot/config.svelte'
import session from '../../util/session'

up.compiler(
  '[data-chat-bot-widget]',
  (
    element,
    {
      base_stream_uri: baseStreamUri,
      identifier,
      feedback_path_template: feedbackPathTemplate,
      video_id: videoId,
      subject_area: subjectArea,
      info_message: infoMessage,
      my_chats_url: myChatsUrl,
      folders_url: foldersUrl,
      login_url: loginUrl,
      starters,
    }: {
      base_stream_uri: string
      identifier?: string
      feedback_path_template?: string
      video_id: string
      subject_area?: string
      info_message?: string
      my_chats_url?: string
      folders_url?: string
      login_url?: string
      starters?: Starter[]
    },
  ) => {
    let currentVideoId = videoId
    let disposed = false
    let chatBot:
      | {
          unmount: () => Promise<void>
          setExtraStreamParams: (params: { video_id: string }) => void
        }
      | undefined

    const inlineContainer = document.querySelector<HTMLElement>('[data-chat-bot-inline-container]')

    if (inlineContainer) {
      void import('frontend/unpoly/javascripts/chat_bot/components/InlineChatBot.svelte').then(
        ({ default: InlineChatBot }) => {
          if (disposed) return

          const app = mount(InlineChatBot, {
            target: inlineContainer,
            props: {
              dispatchEvent: inlineContainer.dispatchEvent.bind(inlineContainer),
              baseStreamUri,
              identifier,
              feedbackPathTemplate,
              infoMessage,
              myChatsUrl,
              foldersUrl,
              loginUrl,
              starters,
              signedIn: session.signedIn ?? undefined,
              variant: 'frontend' as const,
              extraStreamParams: {
                video_id: currentVideoId,
                subject_area: subjectArea,
              },
            },
          })

          chatBot = {
            unmount: () => unmount(app),
            setExtraStreamParams: (params) => app.setExtraStreamParams(params),
          }
        },
      )
    }

    const unbindKeep = up.on(element, 'up:fragment:keep', ({ newData }) => {
      const { video_id } = newData as { video_id: string }
      currentVideoId = video_id
      chatBot?.setExtraStreamParams({ video_id })
    })

    return () => {
      disposed = true
      unbindKeep()
      void chatBot?.unmount()
    }
  },
)
